import React from 'react';
import { LinkProps } from 'react-router-dom';

import { Link } from '../Link';

type Props = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'className'> | LinkProps;

export const NotificationAction = ({ children, ...props }: Props) => {
  if ('to' in props) {
    return <Link {...props}>{children}</Link>;
  }

  return (
    <button {...props} type="button" className="link">
      {children}
    </button>
  );
};
